import { Injectable } from '@angular/core';

export interface CountryCode {
  name: string;
  iso2: string;
  dial_code: string;
}

@Injectable({
  providedIn: 'root',
})
export class CountryCodeService {
  private readonly countryCodes: CountryCode[] = [
    {
      name: 'India',
      iso2: 'IN',
      dial_code: '+91',
    },
    {
      name: 'Afghanistan',
      iso2: 'AF',
      dial_code: '+93',
    },
    {
      name: 'Åland Islands',
      iso2: 'AX',
      dial_code: '+358',
    },
    {
      name: 'Albania',
      iso2: 'AL',
      dial_code: '+355',
    },
    {
      name: 'Algeria',
      iso2: 'DZ',
      dial_code: '+213',
    },
    {
      name: 'American Samoa',
      iso2: 'AS',
      dial_code: '+1684',
    },
    {
      name: 'Andorra',
      iso2: 'AD',
      dial_code: '+376',
    },
    {
      name: 'Angola',
      iso2: 'AO',
      dial_code: '+244',
    },
    {
      name: 'Argentina',
      iso2: 'AR',
      dial_code: '+54',
    },
    {
      name: 'Armenia',
      iso2: 'AM',
      dial_code: '+374',
    },
    {
      name: 'Australia',
      iso2: 'AU',
      dial_code: '+61',
    },
    {
      name: 'Austria',
      iso2: 'AT',
      dial_code: '+43',
    },
    {
      name: 'Azerbaijan',
      iso2: 'AZ',
      dial_code: '+994',
    },
    {
      name: 'Bahamas',
      iso2: 'BS',
      dial_code: '+1242',
    },
    {
      name: 'Bahrain',
      iso2: 'BH',
      dial_code: '+973',
    },
    {
      name: 'Bangladesh',
      iso2: 'BD',
      dial_code: '+880',
    },
    {
      name: 'Barbados',
      iso2: 'BB',
      dial_code: '+1246',
    },
    {
      name: 'Belarus',
      iso2: 'BY',
      dial_code: '+375',
    },
    {
      name: 'Belgium',
      iso2: 'BE',
      dial_code: '+32',
    },
    {
      name: 'Belize',
      iso2: 'BZ',
      dial_code: '+501',
    },
    {
      name: 'Benin',
      iso2: 'BJ',
      dial_code: '+229',
    },
    {
      name: 'Bhutan',
      iso2: 'BT',
      dial_code: '+975',
    },
    {
      name: 'Bolivia',
      iso2: 'BO',
      dial_code: '+591',
    },
    {
      name: 'Bosnia and Herzegovina',
      iso2: 'BA',
      dial_code: '+387',
    },
    {
      name: 'Botswana',
      iso2: 'BW',
      dial_code: '+267',
    },
    {
      name: 'Brazil',
      iso2: 'BR',
      dial_code: '+55',
    },
    {
      name: 'Brunei Darussalam',
      iso2: 'BN',
      dial_code: '+673',
    },
    {
      name: 'Bulgaria',
      iso2: 'BG',
      dial_code: '+359',
    },
    {
      name: 'Burkina Faso',
      iso2: 'BF',
      dial_code: '+226',
    },
    {
      name: 'Burundi',
      iso2: 'BI',
      dial_code: '+257',
    },
    {
      name: 'Cambodia',
      iso2: 'KH',
      dial_code: '+855',
    },
    {
      name: 'Cameroon',
      iso2: 'CM',
      dial_code: '+237',
    },
    {
      name: 'Canada',
      iso2: 'CA',
      dial_code: '+1',
    },
    {
      name: 'Cape Verde',
      iso2: 'CV',
      dial_code: '+238',
    },
    {
      name: 'Central African Republic',
      iso2: 'CF',
      dial_code: '+236',
    },
    {
      name: 'Chad',
      iso2: 'TD',
      dial_code: '+235',
    },
    {
      name: 'Chile',
      iso2: 'CL',
      dial_code: '+56',
    },
    {
      name: 'China',
      iso2: 'CN',
      dial_code: '+86',
    },
    {
      name: 'Colombia',
      iso2: 'CO',
      dial_code: '+57',
    },
    {
      name: 'Comoros',
      iso2: 'KM',
      dial_code: '+269',
    },
    {
      name: 'Congo',
      iso2: 'CG',
      dial_code: '+242',
    },
    {
      name: 'Costa Rica',
      iso2: 'CR',
      dial_code: '+506',
    },
    {
      name: 'Croatia',
      iso2: 'HR',
      dial_code: '+385',
    },
    {
      name: 'Cuba',
      iso2: 'CU',
      dial_code: '+53',
    },
    {
      name: 'Cyprus',
      iso2: 'CY',
      dial_code: '+357',
    },
    {
      name: 'Czech Republic',
      iso2: 'CZ',
      dial_code: '+420',
    },
    {
      name: 'Denmark',
      iso2: 'DK',
      dial_code: '+45',
    },
    {
      name: 'Djibouti',
      iso2: 'DJ',
      dial_code: '+253',
    },
    {
      name: 'Dominica',
      iso2: 'DM',
      dial_code: '+1767',
    },
    {
      name: 'Dominican Republic',
      iso2: 'DO',
      dial_code: '+1809',
    },
    {
      name: 'Ecuador',
      iso2: 'EC',
      dial_code: '+593',
    },
    {
      name: 'Egypt',
      iso2: 'EG',
      dial_code: '+20',
    },
    {
      name: 'El Salvador',
      iso2: 'SV',
      dial_code: '+503',
    },
    {
      name: 'Estonia',
      iso2: 'EE',
      dial_code: '+372',
    },
    {
      name: 'Ethiopia',
      iso2: 'ET',
      dial_code: '+251',
    },
    {
      name: 'Fiji',
      iso2: 'FJ',
      dial_code: '+679',
    },
    {
      name: 'Finland',
      iso2: 'FI',
      dial_code: '+358',
    },
    {
      name: 'France',
      iso2: 'FR',
      dial_code: '+33',
    },
    {
      name: 'Germany',
      iso2: 'DE',
      dial_code: '+49',
    },
    {
      name: 'Ghana',
      iso2: 'GH',
      dial_code: '+233',
    },
    {
      name: 'Greece',
      iso2: 'GR',
      dial_code: '+30',
    },
    {
      name: 'Greenland',
      iso2: 'GL',
      dial_code: '+299',
    },
    {
      name: 'Guatemala',
      iso2: 'GT',
      dial_code: '+502',
    },
    {
      name: 'Honduras',
      iso2: 'HN',
      dial_code: '+504',
    },
    {
      name: 'Hong Kong',
      iso2: 'HK',
      dial_code: '+852',
    },
    {
      name: 'Hungary',
      iso2: 'HU',
      dial_code: '+36',
    },
    {
      name: 'Iceland',
      iso2: 'IS',
      dial_code: '+354',
    },
    {
      name: 'Indonesia',
      iso2: 'ID',
      dial_code: '+62',
    },
    {
      name: 'Iran',
      iso2: 'IR',
      dial_code: '+98',
    },
    {
      name: 'Iraq',
      iso2: 'IQ',
      dial_code: '+964',
    },
    {
      name: 'Ireland',
      iso2: 'IE',
      dial_code: '+353',
    },
    {
      name: 'Israel',
      iso2: 'IL',
      dial_code: '+972',
    },
    {
      name: 'Italy',
      iso2: 'IT',
      dial_code: '+39',
    },
    {
      name: 'Jamaica',
      iso2: 'JM',
      dial_code: '+1876',
    },
    {
      name: 'Japan',
      iso2: 'JP',
      dial_code: '+81',
    },
    {
      name: 'Jordan',
      iso2: 'JO',
      dial_code: '+962',
    },
    {
      name: 'Kazakhstan',
      iso2: 'KZ',
      dial_code: '+7',
    },
    {
      name: 'Kenya',
      iso2: 'KE',
      dial_code: '+254',
    },
    {
      name: 'Kuwait',
      iso2: 'KW',
      dial_code: '+965',
    },
    {
      name: 'Kyrgyzstan',
      iso2: 'KG',
      dial_code: '+996',
    },
    {
      name: 'Laos',
      iso2: 'LA',
      dial_code: '+856',
    },
    {
      name: 'Latvia',
      iso2: 'LV',
      dial_code: '+371',
    },
    {
      name: 'Lebanon',
      iso2: 'LB',
      dial_code: '+961',
    },
    {
      name: 'Lesotho',
      iso2: 'LS',
      dial_code: '+266',
    },
    {
      name: 'Liberia',
      iso2: 'LR',
      dial_code: '+231',
    },
    {
      name: 'Libya',
      iso2: 'LY',
      dial_code: '+218',
    },
    {
      name: 'Lithuania',
      iso2: 'LT',
      dial_code: '+370',
    },
    {
      name: 'Luxembourg',
      iso2: 'LU',
      dial_code: '+352',
    },
    {
      name: 'Macao',
      iso2: 'MO',
      dial_code: '+853',
    },
    {
      name: 'Macedonia',
      iso2: 'MK',
      dial_code: '+389',
    },
    {
      name: 'Madagascar',
      iso2: 'MG',
      dial_code: '+261',
    },
    {
      name: 'Malawi',
      iso2: 'MW',
      dial_code: '+265',
    },
    {
      name: 'Malaysia',
      iso2: 'MY',
      dial_code: '+60',
    },
    {
      name: 'Maldives',
      iso2: 'MV',
      dial_code: '+960',
    },
    {
      name: 'Mali',
      iso2: 'ML',
      dial_code: '+223',
    },
    {
      name: 'Malta',
      iso2: 'MT',
      dial_code: '+356',
    },
    {
      name: 'Mauritius',
      iso2: 'MU',
      dial_code: '+230',
    },
    {
      name: 'Mexico',
      iso2: 'MX',
      dial_code: '+52',
    },
    {
      name: 'Moldova',
      iso2: 'MD',
      dial_code: '+373',
    },
    {
      name: 'Monaco',
      iso2: 'MC',
      dial_code: '+377',
    },
    {
      name: 'Mongolia',
      iso2: 'MN',
      dial_code: '+976',
    },
    {
      name: 'Montenegro',
      iso2: 'ME',
      dial_code: '+382',
    },
    {
      name: 'Morocco',
      iso2: 'MA',
      dial_code: '+212',
    },
    {
      name: 'Mozambique',
      iso2: 'MZ',
      dial_code: '+258',
    },
    {
      name: 'Myanmar',
      iso2: 'MM',
      dial_code: '+95',
    },
    {
      name: 'Namibia',
      iso2: 'NA',
      dial_code: '+264',
    },
    {
      name: 'Nepal',
      iso2: 'NP',
      dial_code: '+977',
    },
    {
      name: 'Netherlands',
      iso2: 'NL',
      dial_code: '+31',
    },
    {
      name: 'New Zealand',
      iso2: 'NZ',
      dial_code: '+64',
    },
    {
      name: 'Nicaragua',
      iso2: 'NI',
      dial_code: '+505',
    },
    {
      name: 'Niger',
      iso2: 'NE',
      dial_code: '+227',
    },
    {
      name: 'Nigeria',
      iso2: 'NG',
      dial_code: '+234',
    },
    {
      name: 'North Korea',
      iso2: 'KP',
      dial_code: '+850',
    },
    {
      name: 'Norway',
      iso2: 'NO',
      dial_code: '+47',
    },
    {
      name: 'Oman',
      iso2: 'OM',
      dial_code: '+968',
    },
    {
      name: 'Pakistan',
      iso2: 'PK',
      dial_code: '+92',
    },
    {
      name: 'Panama',
      iso2: 'PA',
      dial_code: '+507',
    },
    {
      name: 'Paraguay',
      iso2: 'PY',
      dial_code: '+595',
    },
    {
      name: 'Peru',
      iso2: 'PE',
      dial_code: '+51',
    },
    {
      name: 'Philippines',
      iso2: 'PH',
      dial_code: '+63',
    },
    {
      name: 'Poland',
      iso2: 'PL',
      dial_code: '+48',
    },
    {
      name: 'Portugal',
      iso2: 'PT',
      dial_code: '+351',
    },
    {
      name: 'Puerto Rico',
      iso2: 'PR',
      dial_code: '+1939',
    },
    {
      name: 'Qatar',
      iso2: 'QA',
      dial_code: '+974',
    },
    {
      name: 'Romania',
      iso2: 'RO',
      dial_code: '+40',
    },
    {
      name: 'Russia',
      iso2: 'RU',
      dial_code: '+7',
    },
    {
      name: 'Rwanda',
      iso2: 'RW',
      dial_code: '+250',
    },
    {
      name: 'Saudi Arabia',
      iso2: 'SA',
      dial_code: '+966',
    },
    {
      name: 'Senegal',
      iso2: 'SN',
      dial_code: '+221',
    },
    {
      name: 'Serbia',
      iso2: 'RS',
      dial_code: '+381',
    },
    {
      name: 'Seychelles',
      iso2: 'SC',
      dial_code: '+248',
    },
    {
      name: 'Singapore',
      iso2: 'SG',
      dial_code: '+65',
    },
    {
      name: 'Slovakia',
      iso2: 'SK',
      dial_code: '+421',
    },
    {
      name: 'Slovenia',
      iso2: 'SI',
      dial_code: '+386',
    },
    {
      name: 'South Africa',
      iso2: 'ZA',
      dial_code: '+27',
    },
    {
      name: 'South Korea',
      iso2: 'KR',
      dial_code: '+82',
    },
    {
      name: 'Spain',
      iso2: 'ES',
      dial_code: '+34',
    },
    {
      name: 'Sri Lanka',
      iso2: 'LK',
      dial_code: '+94',
    },
    {
      name: 'Sudan',
      iso2: 'SD',
      dial_code: '+249',
    },
    {
      name: 'Sweden',
      iso2: 'SE',
      dial_code: '+46',
    },
    {
      name: 'Switzerland',
      iso2: 'CH',
      dial_code: '+41',
    },
    {
      name: 'Syria',
      iso2: 'SY',
      dial_code: '+963',
    },
    {
      name: 'Taiwan',
      iso2: 'TW',
      dial_code: '+886',
    },
    {
      name: 'Tanzania',
      iso2: 'TZ',
      dial_code: '+255',
    },
    {
      name: 'Thailand',
      iso2: 'TH',
      dial_code: '+66',
    },
    {
      name: 'Togo',
      iso2: 'TG',
      dial_code: '+228',
    },
    {
      name: 'Trinidad and Tobago',
      iso2: 'TT',
      dial_code: '+1868',
    },
    {
      name: 'Tunisia',
      iso2: 'TN',
      dial_code: '+216',
    },
    {
      name: 'Turkey',
      iso2: 'TR',
      dial_code: '+90',
    },
    {
      name: 'Uganda',
      iso2: 'UG',
      dial_code: '+256',
    },
    {
      name: 'Ukraine',
      iso2: 'UA',
      dial_code: '+380',
    },
    {
      name: 'United Arab Emirates',
      iso2: 'AE',
      dial_code: '+971',
    },
    {
      name: 'United Kingdom',
      iso2: 'GB',
      dial_code: '+44',
    },
    {
      name: 'United States',
      iso2: 'US',
      dial_code: '+1',
    },
    {
      name: 'Uruguay',
      iso2: 'UY',
      dial_code: '+598',
    },
    {
      name: 'Uzbekistan',
      iso2: 'UZ',
      dial_code: '+998',
    },
    {
      name: 'Venezuela',
      iso2: 'VE',
      dial_code: '+58',
    },
    {
      name: 'Vietnam',
      iso2: 'VN',
      dial_code: '+84',
    },
    {
      name: 'Yemen',
      iso2: 'YE',
      dial_code: '+967',
    },
    {
      name: 'Zambia',
      iso2: 'ZM',
      dial_code: '+260',
    },
    {
      name: 'Zimbabwe',
      iso2: 'ZW',
      dial_code: '+263',
    },
  ];

  getAll(): CountryCode[] {
    return [...this.countryCodes];
  }

  getByIso(iso2: string): CountryCode | undefined {
    return this.countryCodes.find(
      (c) => c.iso2.toLowerCase() === iso2.toLowerCase()
    );
  }

  getByDialCode(dialCode: string): CountryCode | undefined {
    return this.countryCodes.find((c) => c.dial_code === dialCode);
  }
}
